import { useParams, Link } from 'react-router-dom'
import { Button } from '../../../../components'
import { BrandRoutes } from '../../../BrandRoutes'
import { Brand } from '../../../../gql/types'
import { formatPriceInCents } from '../../../../utils/PricingUtil'

interface IProps {
  brand: Brand
}

const Header = ({ brand }: IProps) => {
  const { id } = useParams()

  const formatCredits = (creditCents, currency) => {
    return formatPriceInCents(
      {
        priceInCents: creditCents,
        currency: currency,
      },
      { minimumFractionDigits: 0 },
    )
  }

  return (
    <div className='sm:flex sm:items-center py-4 px-1'>
      <div className='sm:flex-auto'>
        <div className='flex flex-row'>
          <h1 className='font-bold text-3xl font-outfit'>Campaigns</h1>
        </div>
      </div>
      <div className='mt-2 sm:ml-4 sm:mt-0 sm:flex-none sm:flex sm:items-center sm:gap-4'>
        <div className='text-xs text-gray-600 whitespace-nowrap mb-4 sm:mb-0'>
          {brand?.creditCents > 0 &&
            `You have ${formatCredits(
              brand?.creditCents,
              brand?.currency,
            )} credits available.`}
          {brand?.creditCents === 0 && (
            <>
              <Link
                to={BrandRoutes.creditPacks.replace(':id', `${brand.id}`)}
                className='text-blue-500'
              >
                Buy credit packs
              </Link>{' '}
              and save up to 20%
            </>
          )}
        </div>
        <Button
          title='Create Campaign'
          to={BrandRoutes.newCampaign.replace(':id', `${id}`)}
          className='w-full'
        />
      </div>
    </div>
  )
}

export { Header }
